import { render, staticRenderFns } from "./TplScriptsList.vue?vue&type=template&id=620ee104&scoped=true&"
import script from "./TplScriptsList.vue?vue&type=script&lang=js&"
export * from "./TplScriptsList.vue?vue&type=script&lang=js&"
import style0 from "./TplScriptsList.vue?vue&type=style&index=0&id=620ee104&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620ee104",
  null
  
)

export default component.exports